module.exports = __webpack_public_path__ + "static/media/payment_status_refunded.13725b4b.svg";